import React from 'react'
import AdvertisementItem from './AdvertisementItem'

const AdvertisementsHero = ({items, features}) => {
    const  loginHeaderClassName = features && features.has_userbar ? ' has-login-header' : ''
    const imageURLs = {
        desktop: false,
        mobile: false
    }
    const itemOrigin = 'Overview Hero'

    return (
        <div className={'custom-placements-hero' + loginHeaderClassName}>
            <AdvertisementItem
                item={items[0]}
                imageURLs={imageURLs}
                itemOrigin={itemOrigin}
                imgTag={true}
            />
        </div>
    )
}

export default AdvertisementsHero